export const getNormalizedHexColor = (color: any) => {
	if (typeof color !== 'string') return color;
	if ((color.length === 4 || color.length === 7) && color.match(/^#/))
		return color;
	return `#${color}`;
};

export default getNormalizedHexColor;
